import { combineReducers } from 'redux';

import contact from './contact-details-reducer';
import pending from './pending-upload-check-reducer';
import iverify from './i-verify-reducer';
export default combineReducers( {
                                    pending,
                                    contact,
                                    iverify
                                } );